import React from 'react';

import Button from 'components/Button';
import ExternalLink from 'components/ExternalLink';

import {formatDate} from 'utils/datetime';

import './styles.css';

const PaymentDetails = ({
  gocardlessPayment,
  openPaymentDetailModal,
  openGocardlessCustomerModal
}) => {
  const attempts = `${gocardlessPayment.retryCounter +
    1}/${gocardlessPayment.maxRetries + 1}`;

  return (
    <div className="PaymentDetails">
      <h5 className="header">Details</h5>
      <div className="content">
        <div className="box">
          <div className="title">Attempts</div>
          <div className="text">{attempts}</div>
        </div>
        <div className="box">
          <div className="title">Account</div>
          <div className="text">{gocardlessPayment.xeroAccount}</div>
        </div>
        <div className="box">
          <div className="title">Charge date</div>
          <div className="text">
            {gocardlessPayment.chargeDate &&
              formatDate(gocardlessPayment.chargeDate)}
            {!gocardlessPayment.chargeDate && '-'}
          </div>
        </div>
        <div className="box">
          <div className="title">GC Customer</div>
          <div
            className="text colab-clickable"
            onClick={() =>
              openGocardlessCustomerModal(
                gocardlessPayment.gocardlessCustomerId
              )
            }>
            {gocardlessPayment.gocardlessCustomerName}
          </div>
        </div>
        <div className="box">
          <div className="title">GC ID</div>
          {gocardlessPayment.gocardlessId && (
            <ExternalLink
              className="link-text"
              href={gocardlessPayment.link}
              targetBlank>
              {gocardlessPayment.gocardlessId} →
            </ExternalLink>
          )}
          {!gocardlessPayment.gocardlessId && '-'}
        </div>
        <div className="box">
          <div className="title">Transaction</div>
          <Button
            transparent
            className="link-text"
            onClick={() =>
              openPaymentDetailModal(
                gocardlessPayment.payment.scheduleType,
                gocardlessPayment.payment.id
              )
            }>
            Go to Transaction →
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
